import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MaterialWhereUsed } from 'src/app/models/domain';
import { MaterialWhereUsedAdapter } from 'src/app/models/domain/adapters';
import { HeaderSetService } from 'src/generated-clients/material_whereused';

@Injectable({
  providedIn: 'root',
})
export class MaterialWhereUsedDataService {
  public constructor(
    private readonly materialWhereUsedSetService: HeaderSetService,
    private readonly materialWhereUsedAdapter: MaterialWhereUsedAdapter
  ) {}

  public getMaterialWhereUsedByDesignId(designId: string): Observable<MaterialWhereUsed[]> {
    return this.materialWhereUsedSetService
      .headerSetMaterialmaterialplantplantusageusageToItemsGet(designId, '500', 'M')
      .pipe(
        rethrowAsSapError(),
        map((res) => {
          if (!res.d?.results) {
            throw new Error('SAP Error');
          }

          return res.d.results.map((materialWhereUsed) =>
            this.materialWhereUsedAdapter.adaptToDomain(materialWhereUsed)
          );
        })
      );
  }
}
